import { render } from "./UpgradePlanModal.vue?vue&type=template&id=4fc79773"
import script from "./UpgradePlanModal.vue?vue&type=script&lang=ts"
export * from "./UpgradePlanModal.vue?vue&type=script&lang=ts"
script.render = render

export default script